const Expert = {
  queryList: [
    {
      name: 'name',
      label: '姓名',
      component: 'input'
    },
    {
      name: 'orgName',
      label: '单位',
      component: 'input'
    },
    {
      name: 'idCard',
      label: '证件号码',
      component: 'input'
    },
    {
      name: 'phone',
      label: '手机号',
      component: 'input'
    },
    {
      name: 'mFirstSubjectName',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'mSecondSubjectName',
      label: '二级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confSecondSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'degreeCategoryName',
      label: '专业学位',
      component: 'input'
    },
    {
      name: 'degreeDomainName',
      label: '专业领域',
      component: 'input'
    },
    {
      name: 'researchAreaOne',
      label: '研究方向',
      component: 'input'
    }
  ],
  urlMap: {
    select: '/exp/expInfo/list',
    delete: '/exp/expInfo/delete'
  },
  operList: [// 操作列表
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        type: 'dialog',
        width: 800,
        addr: 'systemManage/expertAdd'
      }
    }
  ],
  titles: [
    {
      name: 'name',
      label: '姓名'
    },
    {
      name: 'orgName',
      label: '单位'
    },
    {
      name: 'idCard',
      label: '证件号码'
    },
    {
      name: 'phone',
      label: '手机号'
    },
    {
      name: 'mFirstSubjectName',
      label: '主要一级学科'
    },
    {
      name: 'mSecondSubjectName',
      label: '主要二级学科'
    },
    {
      name: 'degreeCategoryName',
      label: '专业学位'
    },
    {
      name: 'degreeDomainName',
      label: '专业领域'
    },
    {
      name: 'researchAreaOne',
      label: '研究方向'
    },
    {
      name: 'status',
      label: '状态',
      map: {
        0: '失效',
        1: '有效'
      },
      action: {
        label: '更改',
        type: 'request',
        method: 'fetch',
        addr: '/exp/expInfo/changeStatus/{id}'
      }
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '修改',
          kind: 'primary', // error
          type: 'dialog', // request, router, dialog, func
          width: 800,
          addr: 'systemManage/expertEdit?{id}' // 如果type是request，这里的值是urlMap中的某一个键值
        },
        {
          label: '删除',
          kind: 'primary',
          type: 'request',
          addr: 'delete',
          data: ['{id}'],
          confirm: {
            desc: '确认删除？'
          }
        }
      ]
    }
  ]
}
export default Expert



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/systemManage/expert.js